import React, { useState, FormEvent } from 'react';
import { BaseReact } from '../../base.model';
import Input from '../Forms/Input';
import { Link } from 'react-router-dom';
import Button from '../Forms/Button';
import LogoFullSvg from '../visuals/LogoSvg';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import './Login.scss';


interface LoginProps extends BaseReact {
}

const REST_BASE_URL = (process.env.REACT_APP_HTTP_URL || '').replace(/\/graphql\/?$/, '');

function Login({ history, location }: LoginProps) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');

    const [registering, setRegistering] = useState(false);

    const submitLogin = (e: FormEvent) => {
        e.preventDefault();
        if (!email || !password) {
            return;
        }
        setRegistering(true);
        fetch(`${REST_BASE_URL}/mainuserlogin`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        })
            .then(async (response) => {
                const data = await response.json().catch(() => ({} as { redirect?: string; error?: string }));
                if (response.ok && data.redirect) {
                    // BE has set the signed cookie; jump to the dashboard URL it told us to.
                    window.location.replace(data.redirect);
                    return;
                }
                sharedToasterSubject.next({
                    type: 'error',
                    message: data.error || 'No se pudo iniciar sesión.',
                });
                setRegistering(false);
            })
            .catch((err) => {
                console.error('<Login> Error Logging in: ', err);
                sharedToasterSubject.next({
                    type: 'error',
                    message: 'Error de red, intenta de nuevo.',
                });
                setRegistering(false);
            });
    }

    const _setEmail = (e: string) => {
        setEmail(e.trim().toLowerCase())
    }

    return (
        <div id="Login">
            <form className="_loginForm" onSubmit={submitLogin}>
                <LogoFullSvg size={275} />
                <Input type="text" label="Email" value={email} onChange={_setEmail} placeholder="Tu email u Seller Token" hasError={false} />
                <Input type="password" label="Contraseña" value={password} onChange={setPassword} placeholder="Contraseña" />
                <div className="actions">
                    <Link to="/recover" >¿Olvidaste tu contraseña?</Link>
                    <Button primary={true} type="submit" accent={false} disabled={registering || !(email && password)}>
                        {
                            registering ?
                                <span>Entrando</span>
                                :
                                <span>Entrar</span>
                        }
                    </Button>
                </div>
                <div className="_toRegiser">
                    <Link to="/register">
                        ¿No tienes cuenta? <b>Regístrate</b>
                    </Link>
                </div>
            </form>
        </div>
    )
}

export default Login;
